import request from '@/utils/request';
//单个商品详情
export function getGoodDetail(values) {
  return request('/gift/queryOne', {
    method: 'POST',
    data: values,
  });
}
//新增商品
export function addGood(values) {
  return request('/gift/add', {
    method: 'POST',
    data: values,
  });
}
//更新商品
export function updateGood(values) {
  return request('/gift/update', {
    method: 'POST',
    data: values,
  });
}
